import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import '@/assets/styles/sass/themes/lite-blue.scss'
import VueApexCharts from 'vue-apexcharts'
import auth from '@/firebase/auth'
import 'v2-datepicker/lib/index.css'
import V2Datepicker from 'v2-datepicker'
import VueTheMask from 'vue-the-mask'
import Acl from './plugins/Acl'
import Breadcrumb from './components/breadcrumb'
import i18n from './lang/lang'

const unsubscribe = auth
    .onAuthStateChanged(() => {
        unsubscribe()

        Vue.use(V2Datepicker)
        Vue.use(VueTheMask)
        Vue.use(Vuelidate)
        Vue.use(BootstrapVue)

        Vue.use(Acl, router)
        Vue.config.productionTip = false

        Vue.component('breadcumb', Breadcrumb)
        Vue.component('apexchart', VueApexCharts)

        new Vue({
            computed: {
                user () {
                    return this.$store.getters['auth/user']
                },
            },
            watch: {
                user (user, oldUser) {
                    if (oldUser && !user) {
                        this.$router.push('/signin')
                    }
                },
            },
            router,
            store,
            i18n,
            render: h => h(App),
        }).$mount('#app')
    })
